// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"28679142","667":"98c1b21f","977":"860797e3"}[chunkId] + ".chunk.js");